export const isDisable = (
  mapping,
  mappingIndex,
  parameterIndex,
  role,
  isDataRejectedByProcessor,
  entireBatchRejectedByPro,
  parametersData,
  entireBatchRejectedByInvestigatorValidator,
  reProcessEntireBatch,
  reProcess,
  isDataRejectedByInvestigatorValidator,
  reValidateInvestigatorValidator
) => {
  let isDisable = false; // initially its false
  if (role === "preProcessor") {
    if (parametersData[parameterIndex]?.isNewAddedByPre === true) {
      isDisable = false;
    } else {
      if (
        isDataRejectedByProcessor === true && // getting true when data is rejected
        entireBatchRejectedByPro === false // getting true when entire batch rejected
      ) {
        isDisable =
          mapping?.processorCellRejection?.isRejected === true ||
          parametersData[parameterIndex]?.processorRowRejection?.isRejected ===
            true
            ? false
            : true;
      } else if (
        isDataRejectedByProcessor === true && // getting both flags true when entire batch rejected
        entireBatchRejectedByPro === true
      ) {
        isDisable = false;
      }
      if (
        parametersData[parameterIndex].enableCellsForNewColumn === true &&
        mapping?.newColumn === true
      ) {
        isDisable = false;
      }
    }
  }

  if (role === "processor") {
    if (!entireBatchRejectedByInvestigatorValidator) {
      if (!reProcessEntireBatch) {
        if (reProcess) {
          isDisable = !(
            mapping?.processorCellRejection?.isResolved === true ||
            parametersData[parameterIndex]?.processorRowRejection?.isResolved
          );
        }
        if (isDataRejectedByInvestigatorValidator) {
          if (
            parametersData[parameterIndex]?.isNewAddedByPro === true ||
            parametersData[parameterIndex]?.isNewAddedByPre === true
          ) {
            isDisable = false;
          } else {
            isDisable =
              mapping?.investigatorValidatiorCellRejection?.isRejected ||
              parametersData[parameterIndex]?.investigatorValidatiorRowRejection?.isRejected
                ? false
                : true;
          }
        }
        if (reProcess && isDataRejectedByInvestigatorValidator) {
          // when data rejected by validator and processor and then resolved by pre processor at that time for both rejection we need to enable field
          let disableForProResolve = !(
            mapping?.processorCellRejection?.isResolved === true ||
            parametersData[parameterIndex]?.processorRowRejection?.isResolved
          );
          let disableForInvestigatorValidatorRejection =
            mapping?.investigatorValidatiorCellRejection?.isRejected ||
            parametersData[parameterIndex]?.investigatorValidatiorRowRejection?.isRejected
              ? false
              : true;
          if (
            disableForProResolve === false &&
            disableForInvestigatorValidatorRejection === true
          ) {
            isDisable = false;
          }
        }

        if (
          parametersData[parameterIndex].enableCellsForNewColumn === true &&
          mapping?.newColumn === true
        ) {
          isDisable = false;
        }
      }
    }
    if (role === "investigatorValidatior") {
      if (reValidateInvestigatorValidator) {
        isDisable = !(
          mapping?.investigatorValidatiorCellRejection?.isResolved === true ||
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection?.isResolved
        );
      }
    }
  }
  return isDisable;
};
